import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  createOfflineOrderRequest,
  createOfflineOrderSuccess,
  createOfflineOrderFailure,
  generateOtpRequest,
  generateOtpSuccess,
  generateOtpFailure,
  verifyOtpRequest,
  verifyOtpSuccess,
  verifyOtpFailure,
  verifyOrderRequest,
  verifyOrderSuccess,
  verifyOrderFailure,
  getCustomerOfflineTransactionsRequest,
  getCustomerOfflineTransactionsSuccess,
  getCustomerOfflineTransactionsFailure,
} from "./offlineOrderSlice";
import { toast } from "react-toastify";


function* createOfflineOrder(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/buyMetalOffline`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if(response.data.success)
    {
      const orderId = response.data.data;

       yield put(createOfflineOrderSuccess({orderId}));
       toast.success(response.data.message)
    }
    else {
      yield put(
      createOfflineOrderFailure(response?.data?.message ),
      toast.error(response.data.message)
    );
    }
  } catch (error) {
    yield put(
      createOfflineOrderFailure(error.response?.data?.message || error.message),
    );
  }
}  

function* generateOtp(action) {
  const token = process.env.REACT_APP_PUBLIC_TOKEN;
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/otp-generator/generateotp`,
      action.payload,
      { headers: { 
        version: "1.1.1" ,
        Authorization : token
      } }
    );

    if (response.data.success) {
      yield put(generateOtpSuccess());
      toast.success(response.data.data);
    } else {
      yield put(generateOtpFailure(response.data.message));
      toast.error(response.data.message);
    }
  } catch (error) {
    const msg = error.response?.data?.message || "Failed to generate OTP";
    yield put(generateOtpFailure(msg));
  }
}

function* verifyOtp(action) {
  const token = process.env.REACT_APP_PUBLIC_TOKEN;
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/otp-generator/verifyOtp`,
      action.payload,
      { headers: { 
        version: "1.1.1",
        Authorization : token
       } }
    );


    if (response.data.success) {
      yield put(verifyOtpSuccess());
      toast.success(response.data.data);
    } else {
      yield put(verifyOtpFailure(response.data.message));
      toast.error(response.data.message);
    }
  } catch (error) {
    yield put(verifyOtpFailure(error.response?.data?.message));
  }
}

function* verifyOrder(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/verifyOfflineOrder`,
      action.payload
    );

    if (response.data.success) {
      yield put(verifyOrderSuccess());
      // toast.success("Order Verified Successfully!");
    } else {
      yield put(verifyOrderFailure(response.data.message));
      toast.error(response.data.message);
    }
  } catch (error) {
    yield put(verifyOrderFailure(error.response?.data?.message));
  }
}

function* fetchCustomerOfflineTransactions(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getCustomerOfflineTransaction`)
    );

    if (response.data.success) {
      yield put(getCustomerOfflineTransactionsSuccess(response.data));
      toast.success("Offline transactions fetched successfully");
    } else {
      yield put(
        getCustomerOfflineTransactionsFailure(response.data.message || "Failed to fetch offline transactions")
      );
      toast.error(response.data.message || "Failed to fetch offline transactions");
    }
  } catch (error) {
    yield put(getCustomerOfflineTransactionsFailure(error.message));
    toast.error("Error fetching offline transactions");
  }
}


export function* offlineOrderSaga() {
  yield takeLatest(createOfflineOrderRequest.type, createOfflineOrder);
  yield takeLatest(generateOtpRequest.type, generateOtp);
  yield takeLatest(verifyOtpRequest.type, verifyOtp);
  yield takeLatest(verifyOrderRequest.type, verifyOrder);
  yield takeLatest(getCustomerOfflineTransactionsRequest.type, fetchCustomerOfflineTransactions);
}
